import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";

const PackagePrice = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const [loadingg, setLoadingg] = useState(true);
    const [packages, setPackages] = useState([]);
    const [msg, setMsg] = useState("");

    const fetchDataPackages = async () => {
        setLoadingg(true);
        try {
            const headerss = {
                "accept": "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                "Authorization": "Bearer " + user.token
            };

            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/User/GetPackages",
                { headers: headerss }
            );

            if (res.status === 200 && res.data.success) {
                const filteredPackages = [];

                for (let i = 0; i < res.data.data.length; i++) {
                    const p = res.data.data[i];

                    if (!p.isActive) continue;

                    if (
                        (user.role === "Yönetici" && !p.isInvidual) ||
                        (user.role === "Öğrenci" && p.isInvidual)
                    ) {
                        filteredPackages.push({
                            id: p.id,
                            packageName: p.packageName,
                            packageDetail: p.packageDetail,
                            packagePrice: p.packagePrice,
                            howManyDays: p.howManyDays
                        });
                    }
                }

                setPackages(filteredPackages);
            } else {
                setMsg(res.data.message || t("unexpectedError"));
            }
        } catch (err) {
            setMsg(err.message);
        }
        setLoadingg(false);
    };

    useEffect(() => {
        fetchDataPackages();
    }, []);

    return (
        <div className="container my-5">
            <div className="card shadow-sm">
                <div className="card-body">

                    <h3 className="text-center mb-3">
                        {t('packages&prices')}
                    </h3>
                    <p className="text-center text-muted mb-4">
                        {t("packagesList")}
                    </p>

                    {loadingg && (
                        <div className="alert alert-info text-center">
                            {t("loading")}...
                        </div>
                    )}

                    {!loadingg && msg && (
                        <div className="alert alert-warning text-center">
                            {msg}
                        </div>
                    )}

                    {!loadingg && !msg && (
                        <div className="table-responsive">
                            <table className="table table-hover table-bordered align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: "80px" }}>
                                            {t("id")}
                                        </th>
                                        <th>{t("packageName")}</th>
                                        <th>{t("packageDescription")}</th>
                                        <th style={{ width: "150px" }}>
                                            {t("packagePrice")}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {packages.map((dt) => (
                                        <tr key={dt.id}>
                                            <td className="fw-bold">
                                                {dt.id}
                                            </td>
                                            <td>
                                                {dt.packageName}
                                            </td>
                                            <td className="text-muted">
                                                {dt.packageDetail}
                                            </td>
                                            <td>
                                                <span className="badge bg-success fs-6">
                                                    {dt.packagePrice}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default PackagePrice;
